import React from 'react';
import {NumberFormatStyled} from './NumberFormatStyled';

const VendNumberFormat = ({field, prefix, value, form}) => {
    return (<NumberFormatStyled thousandSeparator={true} prefix={prefix} value={value} onValueChange={({value:newValue}) => {
        form.setFieldValue(field.name, newValue);
    }}/>)
};

export default VendNumberFormat;